import React from "react";
import styles from "../../Styles/creator/styles.module.css";
// import play from "../../images/video.jpg";

import ViewModal from "../Modals/ViewModal";

import Popover from "@mui/material/Popover";
import { Typography } from "@mui/material";

function Video2({ del, video, list, setStatus, toast, playlistId }) {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const popen = Boolean(anchorEl);

  const title = video.title;

  return (
    <div className={styles.video}>
      <div className={styles.image} onClick={() => setOpen((val) => !val)}>
        <img src={video.thumbnail} alt="" />
      </div>
      <div className={styles.text3}>
        <span>{title}</span>
        <br />
        {/* <span>-Part 1</span> */}
      </div>

      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={popen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ p: 1 }}>Delete</Typography>
      </Popover>
      {open && (
        <ViewModal
          open={open}
          setOpen={setOpen}
          videoUrl={video?.videoName}
          playlistId={playlistId}
        />
      )}
    </div>
  );
}
export default Video2;
